import React from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useCompany, updateCompany } from 'api';
import { Title, Form, Input, Loading, Button } from 'ui';
import "./index.css";


export default function Company() {
  
  const history = useHistory();
  const match = useRouteMatch();
  const company = useCompany(match.params.companyId);
  
  if(!company) {
    return <Loading/>;
  }
  
  async function save(data) {
    await updateCompany(match.params.companyId, data); 
    history.push('view');
  }
  
  function cancel() {
    history.push('view');
  }
  
  return (
    <Form value={company} onSubmit={save} className="editcompany">
    
      <Title>Edit Company Details</Title>
    
      <Input 
        name="name"
        label="Company Name"
      />
      
      <Input 
        name="email"
        label="Email Address"
      />
      
      <div className="editcompany-address2">
        <Input 
          name="street"
          label="Street"
        />
      </div>
      
      <div className="editcompany-address2">
        <Input 
          name="city"
          label="City"
        />
        <Input 
          name="state"
          label="State"
        />
        <Input 
          name="zip"
          label="zip"
        />
      </div>  
      
      <div className="editcompany-actions">
        <Button label="Save" submit/>
        <Button tertiary label="Cancel" onClick={cancel}/>
      </div>
      
    </Form>
  );
}